import React, { ReactElement } from 'react';
import { connect } from 'react-redux';
import { AppState } from '../..';
import Header from '../header/Header';
import { IAuthReducerState } from '../../reducers/authReducer';
import Helmet from 'react-helmet';
import Nav from '../../components/nav/Nav';
import { Switch } from 'react-router';
import './Container.scss';

interface IContainer {
  authReducer: IAuthReducerState,
  children: ReactElement | Array<ReactElement>
}

const Container: React.FC<IContainer> = ({ authReducer, children }) => {
  const { parsedToken } = authReducer;

  if (parsedToken) {
    return (
      <div>
        <Helmet defaultTitle="Billsby" titleTemplate="Billsby - %s" />
        <div className={"container container__logged"}>
          <div className="container__sidebar">
            <Nav />
          </div>
          <div className="container__content-wrapper">
            <div className="container__content">
              <Switch>
                {children}
              </Switch>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div>
      <Header />
      <div className={"container container__not-logged"}>
        <div className="container__content-wrapper">
          <div className="container__content">
            <Switch>
              {children}
            </Switch>
          </div>
        </div>
      </div>
    </div>
  )
}

export default connect((state: AppState) => ({ authReducer: state.auth }))(Container);